/**
 * This service tracks browser sessions and reports them to
 * the API whenever a new session is created.
 *
 * A "session" is defined as any period of time that is preceded
 * by 30 minutes or more of inactivity.
 */

angular.module('tgaAdmin').service('analyticsService', [
  '$timeout',
  '$window',
  'envService',
  'authService',
  'urlService',
  'IdleTimer',
  'localStorageService',
  function ($timeout, $window, envService, authService, urlService, IdleTimer, localStorageService) {
    const serverAddress = envService.read('serverAddress');
    const MILLISECOND = 1000;
    const SESSION_KEY = 'sid';
    const EXPIRATION_KEY = 'sxp';
    const INACTIVITY_BUFFER = 60 * 30; // 30 minutes
    let loginTimer;

    function postSession() {
      // Using navigator.sendBeacon so data can be sent when page closes
      const auth = authService.getAuthentication();
      const sid = localStorageService.get(SESSION_KEY, 'localStorage');

      if (sid && auth.userId) {
        const data = new FormData();
        data.append('sid', sid);
        data.append('user_id', auth.userId);
        data.append('domain', urlService.domain);
        navigator.sendBeacon(`${serverAddress}analytics/session`, data);
      }
    }

    function setExpiration(exp) {
      // User must be logged in to update expiration otherwise a logged out
      // user could extend expiration without posting a new session ID
      if (authService.getAuthentication()?.isAuth) {
        localStorageService.set(EXPIRATION_KEY, exp, 'localStorage');
      }
    }

    // Check if new session ID needs to be created
    function checkSession() {
      $timeout.cancel(loginTimer);

      // Don't actually create a session until user is logged in
      // because endpoint currently requires a user
      if (!authService.getAuthentication()?.isAuth) {
        loginTimer = $timeout(() => {
          checkSession();
        }, 10000);
        return;
      }

      const now = Date.now();

      if (
        localStorageService.get(SESSION_KEY, 'localStorage') === null
        || localStorageService.get(EXPIRATION_KEY, 'localStorage') === null
        || now > parseInt(localStorageService.get(EXPIRATION_KEY, 'localStorage'), 10)
      ) {
        // Create new session ID
        localStorageService.set(SESSION_KEY, uuidv4(), 'localStorage');
      }

      postSession();
      setExpiration(now + INACTIVITY_BUFFER * MILLISECOND);
    }

    function init() {
      // Initialize the session
      checkSession();

      const sessionMonitor = new IdleTimer();
      sessionMonitor.options.inactive = 60; // seconds
      sessionMonitor.options.disableOnInactive = false;

      sessionMonitor.on('inactive', () => {
        postSession();
        setExpiration(sessionMonitor.user.action + INACTIVITY_BUFFER * MILLISECOND);
        sessionMonitor.on('activity', () => {
          sessionMonitor.off('activity');
          checkSession();
        });
      });

      $window.onbeforeunload = function () {
        if (Date.now() - sessionMonitor.user.action < INACTIVITY_BUFFER * MILLISECOND) {
          postSession();
        }
        setExpiration(sessionMonitor.user.action + INACTIVITY_BUFFER * MILLISECOND);
      };
    }

    return {
      init,
    };
  },
]);
